import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import * as React from "react";
import "./index.scss";
export default function BreadCrumbs({ links }) {
  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<div className="circle" />}
        aria-label="breadcrumb"
        color="rgba(102, 102, 103, 0.6)"
      >
        {links}
      </Breadcrumbs>
    </Stack>
  );
}
